/*!
* Copyright (c) 2018-present Cyclope.ai
* LICENSE file is in the root directory of this source tree.
* */

import Component from '@apps-shared/menu/component'
import * as React from 'react';
import * as Utils from '@root-utils/index';
import * as URL from "@apps-enums/index";
import { DeconnexionActionCreator } from "@apps-store/action-creator";
import { connect } from "react-redux";
import { Dispatch , bindActionCreators } from "redux";
import * as Lodash from 'lodash'

class Container extends React.PureComponent<any, any> {

    public constructor(props: any){

        super(props);

        this.state = { 

            menuactive:[false,false],

        };

        this.onMenuClick = this.onMenuClick.bind(this);
        this.hideShowmenu = this.hideShowmenu.bind(this);
        this.onLogout = this.onLogout.bind(this);
        
    }
    
    /**
     * @function hideShowmenu
     * @param event
     */
    public hideShowmenu = ( event: any) => {
        
        Utils.hideShowmenu(); // show menu 

    }
    /**
     * @function onUpdatedState,
     * @param menuActive
     */
    public onUpdatedState =(paramMenuactive: any) => {

  
        localStorage.setItem("menuactive",paramMenuactive);

        const menuactive: any = [];
        const MM: any = [];
        const menu : any = document.querySelectorAll(".menuText");

        for (const i of  menu.length) {
            MM.push(i);
            menuactive.push(false);
           
        }
     
        if(paramMenuactive !== null  ){

            menuactive[paramMenuactive] = true;
                      
        }
            
        this.setState({ menuactive })

    }
    /**
     * @function componentDidMount
     */
    public componentDidMount(){

        
        const Location: any[] = location.href.split('/'); // gestion des Urls

        /**
         * gestion des Url et le status des menus
         */
        
        const paramRealTimes: boolean =  Utils.transformObjectToArray(Location).includes(URL.EnumUrl.REALTIME$);
        const paramDelayed: boolean =  Utils.transformObjectToArray(Location).includes(URL.EnumUrl.DELAYED$);
        
        if(paramRealTimes){this.onUpdatedState("0")}

        else if(paramDelayed){this.onUpdatedState("1") }

      
        
    }

    /**
     * @function onLogout
     * @param void
     */ 
    public onLogout = (event: any) =>{

        this.props.DeconnexionActionCreator()
        .then( ()=> { if(!Lodash.isUndefined(this.props.data)){location.reload() }});

    }

    /**
     * @function onMenuClick
     * @param param
     * @param event
     */
    public onMenuClick = (param: any) => (event: any) =>{

        event.preventDefault();

        const menuactive: any = [];
        const MM: any = [];
      

        const menu : any = document.querySelectorAll(".menuText");

        for (const i of  menu.length ) {
            
            MM.push(i);
            menuactive.push(false)
           
        }

        menuactive[param] = true;

        this.setState({

            menuactive,
    
        })
        localStorage.setItem("menuactive",param);

    }
    

    public render() {
      
        return <Component onLogout={this.onLogout} hideShowmenu={this.hideShowmenu} {...this.state} {...this.props} onMenuClick={this.onMenuClick}/>

    }

}

/**
 * @function mapStateToProps
 * @param { any }  state 
 * @return { any }
 */
const mapStateToProps = (state : any) => ({ data:state.logout.data , error:state.logout.error });


const mapDispatchToProps = (dispatch : Dispatch) =>
    bindActionCreators({
        DeconnexionActionCreator
    }, dispatch);


export default connect(mapStateToProps,mapDispatchToProps)(Container);



// WEBPACK FOOTER //
// ./src/apps/components/@shared/menu/container.tsx